import { useImpersonation } from '@/hooks/useImpersonation';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Badge } from '@/components/ui/badge';
import { X, User, Clock } from 'lucide-react';

export function ImpersonationBanner() {
  const {
    isImpersonating,
    impersonatedUserEmail,
    getFormattedRemainingTime,
    remainingTimeMs,
    stopImpersonation
  } = useImpersonation();

  if (!isImpersonating) {
    return null;
  }

  // Show warning color when less than 5 minutes remaining
  const isLowTime = remainingTimeMs < 5 * 60 * 1000;

  return (
    <Alert className="dark:bg-warning/20/20 mb-4 border-warning bg-warning/5">
      <User className="size-4 text-warning dark:text-warning" />
      <AlertTitle className="flex items-center gap-2 text-warning-foreground dark:text-warning-foreground">
        Viewing as: {impersonatedUserEmail}
        <Badge
          variant={isLowTime ? "destructive" : "secondary"}
          className="ml-2 gap-1"
        >
          <Clock className="size-3" />
          {getFormattedRemainingTime()}
        </Badge>
      </AlertTitle>
      <AlertDescription className="flex items-center justify-between text-warning dark:text-yellow-300">
        <span>
          Viewing this portal as another user.
          {isLowTime && " Session expires soon!"}
        </span>
        <Button
          variant="outline"
          size="sm"
          onClick={stopImpersonation}
          className="ml-4 border-yellow-600 text-warning-foreground hover:bg-warning/10 dark:border-yellow-400 dark:text-warning-foreground dark:hover:bg-yellow-900/30"
        >
          <X className="mr-2 size-4" />
          Stop
        </Button>
      </AlertDescription>
    </Alert>
  );
}
